module.exports = __webpack_public_path__ + "static/asana-0666cf03e39b143d12d533509d44b483.svg";